//=====================================================
//　予約情報
//=====================================================
import { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { getApiDataWithToken } from "./CallApi";
import { IFUseAuth } from "./UseAuth";
import { ConstMsg } from "../utils/ConstMsg";
import { IFUseSystemErr } from "./UseSystemErr";

//予約情報IF
export interface IFDataReservationInfo {
    reserveId: string,
    determination: boolean,
    datetime: string,
    doctorName: string,
    medicalTypeId: string,
    medicalType: string,
    time: string,
    operation: {
        add: boolean,
        update: boolean,
        delete: boolean
    }
}

//予約情報
export const InitDataReservationInfo:IFDataReservationInfo = {
    reserveId: "",
    determination: false,
    datetime: "",
    doctorName: "",
    medicalTypeId: "",
    medicalType: "",
    time: "",
    operation: {
        add: false,
        update: false,
        delete: false
    }
}

//予約情報管理IF
export interface IFUseReservationInfo {
    loaded:Boolean;
    data: IFDataReservationInfo[]
}

//-----------------------------------------------------
//　予約情報管理
//-----------------------------------------------------
export function useReservationInfo( ua: IFUseAuth, clinicId:string , patientId:string|null, determination:boolean, userr:IFUseSystemErr):IFUseReservationInfo{

    const [data, setData] = useState<IFDataReservationInfo[]>([]);
    const [loaded, setLoaded] = useState(false);

    //予約情報取得
    useEffect(
        function(){

            // マウントフラグ
            let isMounted = true;

            setLoaded( false );
            if(ua.isLoggedIn()) {
                let apiUrl = `/auth/c/${clinicId}/reservations/patients/${patientId}`;
                let apiParams = {
                    params: {
                        determination: determination,
                    }
                };
                getApiDataWithToken(
                    apiUrl,
                    apiParams,
                    ua.getToken(),
                    function(res:AxiosResponse<any>){
                        // アンマウント時はstate(history)を更新しないようにする
                        if(isMounted){
                            if (res?.data) {
                                if( res.status === 200 ){
                                    const tmpMenu:IFDataReservationInfo[]=[];
                                    if( res.data.length > 0 ){
                                        res.data.forEach(
                                            function(val: any){
                                                tmpMenu.push(
                                                    {
                                                        reserveId: val.reserveId,
                                                        determination: val.determination,
                                                        datetime: val.datetime,
                                                        doctorName: val.doctorName,
                                                        medicalTypeId: val.medicalTypeId,
                                                        medicalType: val.medicalType,
                                                        time: val.time,
                                                        operation: {
                                                            add: val.operation.add,
                                                            update: val.operation.update,
                                                            delete: val.operation.delete
                                                        }
                                                    }
                                                );
                                            }
                                        );
                                    }
                                    setData(tmpMenu);
                                } else {
                                    userr.setErrmess(res.data.message);
                                }
                            } else {
                                userr.setErrmess(ConstMsg.EG9990001);
                            }
                            setLoaded( true );   
                        } 
                    }                 
                );
            } else {
                setLoaded( true );
            }

            // cleanup関数(Unmount時の処理)
            return () => {
                // マウントオフ
                isMounted = false;
            }
            // 指定すると無限ループするので、clinicId, determination, patientId, uaは第2引数から除外する
            // エラーメッセージを更新するため、userrは第2引数から除外する
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[]
    );

    return { loaded, data }

}